import { Message, MessageBox } from 'element-ui'
import app from '../../../app'

export function toggle(dom, cb, popperid) {
  const wrapperId = popperid || 'popper-wrapper'
  if (!dom.parentNode) {
    return false
  } else if (dom.id === wrapperId || dom.className.indexOf('popper-btn') > -1) {
    return true
  }
  return cb(dom.parentNode, cb, popperid)
}

export function formatAnalyseExp(exps) {
  return (exps || []).map(val => {
    const result = {}
    for (const key in val) {
      // eslint-disable-next-line no-prototype-builtins
      const fieldMap = {
        目前职位: '职位',
        工作职责: '职责',
        工作业绩: '业绩',
        项目职责: '职责',
        项目业绩: '业绩',
        项目描述: '描述',
        项目名称: '名称',
        项目职务: '职位',
        学历: '学位',
      }
      if (['工作职责', '项目职责'].includes(key)) {
        result['职责'] = val[key].replace(/<\/?.+?>/g, '').replace(/[\r\n]/g, '')
      } else if (fieldMap[key]) {
        result[fieldMap[key]] = val[key]
      } else {
        result[key] = val[key]
      }
    }
    return result
  })
}

export const uniqueElementsBy = (arr, fn) =>
  arr.reduce((acc, v) => {
    if (!acc.some(x => fn(v, x))) acc.push(v)
    return acc
  }, [])

export const getRadishIds = arr => {
  if (!arr || arr.length === 0) return []
  return arr.map(v => ({
    id: v.rid || v._id,
    score: v.score,
  }))
}

export const radishScore = radish => {
  const score = 60

  const extra1 = !radish
    ? 0
    : radish['离职意愿度'] > 90
    ? 15
    : radish['离职意愿度'] > 70
    ? 10
    : radish['离职意愿度'] > 50
    ? 5
    : 0
  const extra2 = radish && radish['长期意向'] === 'Y' ? 20 : 0
  return score + extra1 + extra2
}

export const tomorrow = offset => {
  const t = new Date()
  t.setDate(t.getDate() + offset)
  const ret = `${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`
  return ret
}

export const generateImg = data => {
  if (!data) return
  const company = encodeURIComponent(`${data['客户公司'] || ''} ${data['部门'] || ''}`)
  const job = encodeURIComponent(`${data['项目名称'] || ''} ${(data['职能模块'] || '').split('-')[1]}`)
  const location = encodeURIComponent(data['地域'] || '')
  const description = encodeURIComponent(data['寻访方向'] || '')
  const startDate = encodeURIComponent(new Date(data['项目时间']).toDateString())
  const a = document.createElement('a')
  a.target = '_blank'
  a.href = `https://www.alphaconsulting.top/picturegenerator/#/generatePic?company=${company}&job=${job}&location=${location}${
    startDate ? `&startDate=${startDate}` : ''
  }&description=${description}`
  a.click()
}

export const onePiece = async (path, page) => {
  await app.service('project').saveRecords({ type: '查看公司信息', path, page: page || '项目列表' })
  const a = document.createElement('a')
  a.target = '_blank'
  a.href = 'https://www.alphaconsulting.top/wechat/#/tasklist'
  return a.click()
}

export const oneKeyMatch = async ({ mode, project, onNoResult, onConfirm }) => {
  app.root.$refs.OnekeyMatchDrawer.openDrawer({ project, onkeyMatchMode: mode, onConfirm })
}

export const cvInfoMatch = async ({ mode, project, onNoResult, onConfirm }) => {
  app.root.$refs.CvmatchLoading.open()
  const res1 = await app
    .service('file')
    .searchCvInfoV2({ query: { radishQuery: { 职能模块: { $in: [project.职能模块] } } } })
  let allRadishes = []
  if (res1.status == 'success' && res1.data.data.length > 0) {
    const sameCom = res1.data.data.filter(dt => dt.project.客户公司 == project.客户公司)
    allRadishes = sameCom.length > 0 ? sameCom.map(dt => dt.radish) : res1.data.data.map(dt => dt.radish)
  }
  if (allRadishes.length === 0) {
    if (onNoResult) {
      onNoResult()
    } else {
      window.alert('暂时没有提供该项目匹配的人选。')
      app.root.$refs.CvmatchLoading.close()
    }
    return
  }
  const ids = allRadishes.map(radish => radish._id)
  const existProjectRadishes = await app.service('project').radishProject({
    query: {
      pid: project._id,
      rid: { $in: ids },
    },
  })
  const exists = {}
  existProjectRadishes.forEach(projectRadish => {
    exists[projectRadish.rid] = true
  })
  async function callback(radishes) {
    radishes.forEach(radish => {
      if (exists[radish._id]) {
        radish.highlight = true
      }
    })
  }
  app.root.$refs.CvmatchLoading.close()
  window.app.root.$refs.addRadishDrawer.openDrawer('radish', project, ids, mode, callback, onConfirm)
}

export const recommendMatch = async (project, onConfirm) => {
  app.root.$refs.CvmatchLoading.open()
  const result = await window.app.service('project').recommendMatch({ pid: project._id })
  let totalArr = []
  if (!result) {
    window.alert('暂时没有提供该项目匹配的人选。')
    return app.root.$refs.CvmatchLoading.close()
  } else {
    totalArr = result.recommend
    if (!totalArr || totalArr.length === 0) {
      window.alert('没有可以继续匹配的人了。')
      totalArr = []
      return app.root.$refs.CvmatchLoading.close()
    }
  }
  app.root.$refs.OnekeyMatchDrawer.openDrawer({
    project,
    onkeyMatchMode: '智能',
    onConfirm,
    ids: getRadishIds(totalArr),
  })
}

export const resetRecommendation = async project => {
  const result = await app.service('project').resetRecommendation(project)
  let totalArr = []
  if (!result) {
    window.alert('暂时没有提供该项目匹配的人选。')
    app.root.$refs.CvmatchLoading.close()
  } else {
    totalArr = result.recommend
    if (!totalArr || totalArr.length === 0) {
      window.alert('没有可以继续匹配的人了。')
      totalArr = []
    }
  }
  window.app.root.$refs.addRadishDrawer.openDrawer('recommend', project, getRadishIds(totalArr), 'recommend')
}

export const genPositionSpeech = (_project, _company) => {
  const project = _project || {}
  const company = _company || {}
  return `您好！我是专注于 ${project['职能模块'] || ' { 职能模块 } '}  领域的猎头
  目前在帮  ${company['一句话简介'] || ' { 公司介绍 } '}
  寻访  ${project['项目名称'] || ' { 项目名称 } '}
  Basse在  ${(project['地域'] && project['地域'].toString()) || ' { 地域 } '}
  主要看中  ${project['核心要求'] || ' { 核心要求 } '}
  不知您是否感兴趣？`
}

/**
 *
 * @param {Array} arr
 * @param {Function} func
 */
export const arrRemove = (arr, func) =>
  Array.isArray(arr)
    ? arr.filter(func).reduce((acc, val) => {
        arr.splice(arr.indexOf(val), 1)
        return acc.concat(val)
      }, [])
    : []

export const download = async params => {
  if (typeof params !== 'object') {
    throw new Error('下载参数错误')
  }
  const { _id, fileId, md5, originalname, url, preview } = params
  let a = document.createElement('a')
  a.style.display = 'none'
  a.target = '_blank'
  if (!preview) a.download = originalname || ''
  if (url) {
    a.href = generateSafyUrl(url)
  } else if (md5 || _id || fileId) {
    const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
    try {
      const { src } = await window.app.service('file').fetchFileURL(Object.assign(query, { preview }))
      a.href = generateSafyUrl((!src.includes('http') ? window.host : '') + src)
    } catch (e) {
      window.alert((e.response && e.response.message) || e.message)
      console.error(e)
      return
    }
  }
  a.click()
  a = null
  window.app.service('radish').addKpi({ type: 'downloadfile', content: params })
}

export const generateSafyUrl = url => {
  if (location.origin.indexOf('https://') !== -1) {
    url = url.replace('http://', 'https://')
  } else if (location.origin.indexOf('http://') !== -1) {
    url = url.replace('https://', 'http://')
  }
  return url
}

export const objectPickBy = (obj, fn) =>
  Object.keys(obj)
    .filter(k => fn(obj[k], k))
    .reduce((acc, key) => ((acc[key] = obj[key]), acc), {})

export const groupBy = (arr, fn) =>
  arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce((acc, val, i) => {
    acc[val] = (acc[val] || []).concat(arr[i])
    return acc
  }, {})

export const initialize2DArray = (w, h, val = null) =>
  Array.from({ length: h }).map(() => Array.from({ length: w }).fill(val))

export const preview = async file => {
  const originalname = file.originalname || file.filename
  const reg = new RegExp('(.doc|.docx|.ppt|.pptx|.xls|.xlsx|.pdf|.html|.htm|.jpg|.jpeg|.png)$')
  if (reg.test(originalname)) {
    const msg = Message({
      message: `生成预览……${originalname}`,
      duration: 0,
      showClose: true,
    })
    const ref = window.app.root.$refs.cvPreview
    await ref.getFile(file)
    msg && msg.close()
    if (file.type === 'cv' || file.type === '原始简历')
      window.app.service('radish').addKpi({
        type: '阅读简历',
        content: { fileId: file._id, md5: file.md5, originalname },
      })
  } else {
    // download(file)
    Message({
      message: `此类型文件不支持预览`,
    })
  }
}

export const onChangeCategory = async (projectItems, selected, defaultMokuai) => {
  const items = projectItems || []
  const options = (selected && selected.options) || []
  const zhiji = defaultMokuai || options.filter(cat => selected.val.includes(cat.value))
  if (!zhiji) return
  // const zhijiFilter = (zhiji['细分职能'] || []).filter(Boolean)
  // const zhinengOptions = zhijiFilter.map(val => ({
  //   label: val,
  //   value: val,
  // }))
  items.forEach(item => {
    if (item.label === '细分职能') {
      let xifen = []
      zhiji.forEach(v => {
        if (v.细分职能 && v.细分职能.length > 0) {
          v.细分职能.forEach(a => {
            xifen.push(a)
          })
        }
      })
      // 去除同名细分职能
      if (xifen.length > 0) {
        xifen = Array.from(new Set(xifen))
      }
      item.options = xifen.map(v => ({ value: v, label: v }))
      if (!defaultMokuai) item.val = []
    }
    if (item.label === '擅长方向') {
      let shanchang = []
      zhiji.forEach(v => {
        if (v.擅长方向 && v.擅长方向.length > 0) {
          v.擅长方向.forEach(a => {
            shanchang.push(a)
          })
        }
      })
      if (shanchang.length > 0) {
        shanchang = Array.from(new Set(shanchang))
      }
      item.options = shanchang.map(v => ({ value: v, label: v }))
      if (!defaultMokuai) item.val = []
    }
  })
}

export const onChangeCompany = async (projectItems, selected) => {
  const { data } = await window.app.service('company').getDepartments(selected.val)
  if (!data || data.length === 0) return
  const departments = data.filter(Boolean)
  const bumenOptions = departments.map(val => ({
    label: val,
    value: val,
  }))
  projectItems.forEach(item => {
    if (item.label === '部门') {
      item.val = ''
      item.options = bumenOptions
    }
  })
}

export const removeProject = async pid => {
  if (!pid) return
  MessageBox.confirm('此操作将删除该项目, 是否继续?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(async () => {
      try {
        const message = await window.app.service('project').removePorject(pid)
        Message({
          type: 'success',
          message,
        })
        const href = `${window.frontend}/#/projects`
        if (window.location.href == href) {
          window.location.reload()
        } else {
          window.location.href = href
        }
      } catch (error) {
        Message({
          type: 'error',
          message: error.message,
        })
      }
    })
    .catch(() => {})
}

export const parseTemplateText = text => {
  if (!text) return {}
  const paragraphs = text
    .replace(/】（.*?）/g, '】') // 去括号中内容
    .replace(/；/g, ';')
    .split('【')
  const json = {}
  paragraphs.forEach(p => {
    if (!p && !p.trim()) return
    const sessions = p.split('】')
    if (sessions.length < 2) return
    const title = sessions[0].replace(/(^\s*)|(\s*$)/g, '')
    if (!title) return
    let textContent = sessions[1]
    if (!textContent) return
    textContent = textContent.replace(/(^\s*)|(\s*$)/g, '')
    json[title] = textContent
  })
  return json
}

const rankRange = {
  '1': ['1', '2'],
  '2': ['1', '2', '3'],
  '3': ['2', '3', '4'],
  '4': ['3', '4', '5'],
  '5': ['4', '5'],
}

const performanceRange = {
  aaa: ['aaa', 'aa'],
  aa: ['aaa', 'aa'],
  a: ['aaa', 'aa', 'a'],
  b: ['aaa', 'aa', 'a', 'b'],
  c: ['aaa', 'aa', 'a', 'b', 'c'],
  d: ['aaa', 'aa', 'a', 'b', 'c', 'd'],
}

const platformRange = {
  A: ['A'],
  B: ['A', 'B'],
  C: ['A', 'B', 'C'],
}

const flatten = (arr, depth = 1) =>
  arr.reduce((a, v) => a.concat(depth > 1 && Array.isArray(v) ? flatten(v, depth - 1) : v), [])

export function getRankRange(params) {
  if (Array.isArray(params)) {
    if (params.length === 1) {
      return rankRange[params[0]] || []
    } else if (params.length === 2) {
      return Array.from(new Set([...rankRange[params[0]], ...rankRange[params[1]]]))
    }
  }
  return params || []
}

export function getPerformance(params) {
  if (Array.isArray(params) && params.length > 0) {
    const performanceRanges = params.map(value => performanceRange[value])
    const performances = Array.from(new Set(flatten(performanceRanges)))
    return performances.filter(Boolean)
  }
  return params || []
}

export function getPlatform(params) {
  if (Array.isArray(params) && params.length > 0) {
    const platformRanges = params.map(value => platformRange[value])
    const platforms = Array.from(new Set(flatten(platformRanges)))
    return platforms.filter(Boolean)
  }
  return params || []
}

export const average = (...nums) => nums.reduce((acc, val) => acc + val, 0) / nums.length

export const getQueryString = key => {
  const queryStr = window.location.hash.substring(window.location.hash.indexOf('?') + 1)
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)
  const res = queryStr.match(reg)
  if (res != null) return res[2]
  return ''
}

export const formatWorkbook = (data, headers) => {
  let workbook
  const fieldColIndex = {}
  data.forEach((radish, row) => {
    if (!workbook) {
      workbook = initialize2DArray(headers.length, data.length + 1)
      workbook[0] = headers
      headers.forEach((field, col) => {
        if (!fieldColIndex[field]) {
          fieldColIndex[field] = col
        }
      })
    }
    headers.forEach(field => {
      workbook[row + 1][fieldColIndex[field]] = radish[field]
    })
  })
  return workbook
}

export const hasPermisson = project => {
  if ((app.user['角色'] && app.user['角色'].includes('管理员')) || app.user.项目管理) return true
  const perm = []
    .concat(project['客户开发'])
    .concat(project['项目对接'])
    .concat(project['项目经理'])
    .concat(project['项目成员'])
  if (perm.includes(app.user.account)) return true
  return false
}
